import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectComponent } from './select.component';
import { PipesModule } from '../pipes/pipes.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { CheckboxModule } from '../../shared/checkbox/checkbox.module';
@NgModule({
  declarations: [SelectComponent],
  imports: [CommonModule, FormsModule, NgSelectModule, PipesModule, SvgIconModule, CheckboxModule],
  exports: [SelectComponent],
})
export class SelectModule {}
